<template>
<div @mouseleave="hideMsgPopup">
    <transition name="fade">
        <div class="msg-popup" :style="msgPopupPos" :key="clickedUser" @mouseleave="hideMsgPopup">
            <UserPopup :usr="$parent.getUser(clickedUser)" :expoId="expoId"/>
        </div>
    </transition>
    <div class="chat">
        <div class="messages" ref="messages">
            <transition-group name="fade-height-chat" tag="div">
                <Message
                    v-for="message in sortedMessageList"
                    :key="message.msgId"
                    :ref="message.msgId"
                    :usr="$parent.getUser(message.uid)"
                    :msg="message"
                    @click-user="showMsgPopup(message)"
                >
                </Message>
            </transition-group>
        </div>
        <ChatInput v-if="$store.state.user.loggedIn" v-model="draft" v-on:submit="sendMsg"/>
        <a v-else class="info video-wrapper" @click="$router.push({ name: 'Log In', params: { routeAfter: '/expo/'+expoId+'/'+roomStr }})">
            <span class="text">Log in to speak or message</span>
        </a>
    </div>
</div>
</template>

<script>
import ChatInput from './ChatInput'
import Message from './Message'
import UserPopup from '../user/UserPopup'

import { nanoid } from 'nanoid'

import { auth, rtdb, RTDB_TIMESTAMP } from '../../../db'

const chat = rtdb.ref('chat')

export default {
    name: 'Chat',
    props: ['expoId', 'roomStr', 'roomType'],
    components: {
        ChatInput,
        Message,
        UserPopup,
    },
    data() {
        return {
            draft: '',
            messageList: [],
            clickedUser: '',
            clickedUserPos: {}
        }
    },
    computed: {
        sortedMessageList() {
            return [...this.messageList].sort((a,b) => (a.dt > b.dt) ? 1 : ((b.dt > a.dt) ? -1 : 0))
        },
        uidList() {
            return Array.from(new Set(this.messageList.map(msg => msg.uid)))
        },
        msgPopupPos() {
            if (!this.clickedUser) {
                return {
                    top: '-500px', left: '-500px'
                }
            }
            else {
                return this.clickedUserPos
            }
        }
    },
    watch: {
        expoId: {
            immediate: true,
            handler(expoId) {
                this.$rtdbBind('messageList', chat.child(expoId).child(this.roomStr.replaceAll('/','-')).child('messages').orderByChild('dt').limitToLast(100))
            }
        },
        uidList: {
            handler(uidList) {
                this.$parent.updateUserMap(uidList)
            }
        }
    },
    methods: {
        sendMsg() {
            if (!this.roomStr) {
                return
            }
            this.draft = this.draft.trim()
            if (!this.draft) {
                return
            }
            var email = auth.currentUser.email // Don't use $store.state here for security
            var name = auth.currentUser.displayName
            var uid = auth.currentUser.uid
            var msgId = nanoid()

            chat.child(this.expoId).child(this.roomStr.replaceAll('/','-')).child('messages').child(msgId).set({
                text: this.draft,
                uid: uid,
                email: email,
                name: name,
                dt: RTDB_TIMESTAMP,
                msgId: msgId,
            }).catch(e => { console.error(e) })

            this.draft = ''
            this.$nextTick(() => {
                var msgs = this.$refs.messages
                msgs.scrollTop = msgs.scrollHeight
            })
        },
        showMsgPopup(message) {
            this.clickedUser = message.uid
            let rect = this.$refs[message.msgId][0].$el.getBoundingClientRect()
            this.clickedUserPos = {
                top: (rect.top - 35) + 'px', // 35 comes from half the height of (the profile image plus padding)
                left: (rect.right + 13) + 'px'
            }
        },
        hideMsgPopup() {
            this.clickedUser = ''
        }
    },
    created() {
        this.$parent.updateUserMap(this.uidList)
    }
}
</script>

<style lang="scss" scoped>

.msg-popup {
    position: fixed;
    z-index: 600;
}

.chat {
    position: fixed;
    right: 20px;
    top: 50vh;
    height: calc(50vh - 20px);
    width: 20vw;
    min-width: 300px;
    z-index: 500;

    display: flex;
    flex-direction: column;

    font-weight: bold;
    color: white;
    font-size: 16px;
    
    pointer-events: none;

    .messages {
        display: flex;
        flex: 1;
        overflow-y: scroll;
        flex-direction: column-reverse;
    }

    .video-wrapper {
        margin: 10px 10px 20px 0;
        position: relative;
        height: 200px;
        width: calc(100% - 10px);
        overflow: hidden;
        border-radius: 8px;

        &.info {
            cursor: pointer;
            pointer-events: initial;
            transition: max-height 0.2s ease;
            max-height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 20px;
            background-color: black;
            .text {
                z-index: 10;
                margin: 20px;
            }
            .webcam {
                width: 100%;
                position: absolute;
                top: 50%;
                transform: scale(1.1) translateY(-50%);
                filter: brightness(0.4) blur(3px);
            }
            &:hover {
                max-height: 160px;
            }
        }
    }
}

.fade-height-chat-enter-active, .fade-height-chat-leave-active {
    transition: all 0.4s ease;
    transition-property: opacity max-height margin-bottom padding-top padding-bottom backdrop-filter;
}

.fade-height-chat-enter, .fade-height-chat-leave-to {
    opacity: 0;
    max-height: 0px;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-backdrop-filter: none;
}

.fade-height-chat-enter-to, .fade-height-chat-leave {
    opacity: 1;
    max-height: 400px;
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    -webkit-backdrop-filter: blur(20px);
}
</style>